import { defineMessages } from 'react-intl'
export default defineMessages({
  shopItem:{id: 'app.components.Header.shop'},
  shipItem:{id: 'app.components.Header.ship'},
  cartItem: {id: 'app.containers.Shop.CartPage.BreadCrumbSection.cart'},
  pricingItem:{id: 'app.components.Header.pricing'},
  calculatorItem:{id: 'app.components.Header.calculator'},
  profileItem:{id: 'app.components.Header.profile'},
  howItWorksItem:{id: 'app.components.Header.howItWorks'},
  claimedItem:{id: 'app.components.Header.claimed'},
  walletItem:{id: 'app.components.Header.wallet'},
  subscriptionItem:{id: 'app.components.Header.subscription'},
  help:{id: 'app.components.Header.help'},
  logoutItem:{id: 'app.components.Header.logout'},
  loginItem:{id: 'app.components.Header.login'},
  loginRegisterItem:{id: 'app.components.Header.loginRegister'},
  createItem:{id: 'app.components.Header.create'},
  goBackText: { id: 'app.components.Header.goBackText'},
  goHere: { id: 'app.components.Header.goHere'},
  trackLegacyOrdersItem: { id: 'app.components.Header.trackLegacyOrders' },
  trackPurchaseOrdersItem: { id: 'app.components.Header.trackPurchaseOrders' },
  trackShippingOrdersItem: { id: 'app.components.Header.trackShippingOrders' },
  track: { id: 'app.containers.Account.LegacyOrdersPage.track'},
  trackParent: { id: 'app.containers.Account.LegacyOrdersPage.trackParent' },
  offers: { id: 'app.containers.Account.LegacyOrdersPage.offers' },
  addressBook: {id: "app.containers.Account.AccountSideBar.addressBook"},
})


// WEBPACK FOOTER //
// ./app/components/Header/messages.js